module.exports = __webpack_public_path__ + "img/meme_21.8fc43c69.jpg";